import { Injectable } from '@jack-henry/frontend-utils/di';
import { ArpAccountsRequests } from '../../requests/arp/arp-accounts';

@Injectable()
export class ArpAccountsService {
    public getArpAccounts(claimType: string) {
        return ArpAccountsRequests.getArpAccounts(claimType);
    }
}
